export const WORKFLOW_LABELS: Record<string, string> = {
  IMMEDIATE: 'Réservation immédiate',
  QUOTE_REQUIRED: 'Devis requis',
  APPLICATION_REQUIRED: 'Candidature requise',
};

export const WORKFLOW_COLORS: Record<string, string> = {
  IMMEDIATE: '#00758d',
  QUOTE_REQUIRED: '#8E0B56',
  APPLICATION_REQUIRED: '#00303c',
};
